import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Popconfirm, Row, Col } from 'antd';
import VoucherService from "services/voucher"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import _ from "lodash"
import VoucherModal from "components/voucher/add-edit"
import { useApp } from "contexts/app"
const service = new VoucherService();
const { Search } = Input;
const OrderList = () => {
    const { showNotify } = useApp();
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [voucherID, setVoucherID] = useState(false);

    useEffect(() => {
        loadData();
    }, [])
    const loadData = async (info) => {
        var lst = await service.list({ info });
        setData(lst);
    }
    const onSearch = (text) => {
        loadData(text);
    }

    const searchDelay = useMemo(() => _.debounce(onSearch, 500), []);


    const openVoucher = (id) => {
        setVoucherID(id);
        setIsModalOpen(true);
    }
    const onSearchChange = (e) => {

        searchDelay(e.target.value)
    }
    const copy = async text => {
        await window.navigator.clipboard.writeText(text);
        showNotify(`Đã copy ${text}`)
    }
    const deleteVoucher = async id => {
        await service.delete(id);
        loadData();
    }

    const onVoucherSaved = (voucher) => {
        loadData();
    }
    const columns = [
        {
            title: 'Voucher',

            render: (record) => {
                return (
                    <Row>
                        <Col span={12}>
                            <b>{record.code}</b>
                        </Col>
                        <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                                {formatDate(record.create_on)}
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                {record.description}
                            </div>
                        </Col>

                        <Col span={12}>
                            <div style={{ textAlign: "right" }}>

                                {formatCurrency(record.value)}
                            </div>
                        </Col>
                        <Col span={12}>
                            <Space>
                                <div>
                                    Đã sử dụng {record.usages.length} / {record.usage_limit}
                                </div>
                                {record.usages.map(use => {
                                    return (
                                        <div>
                                            {use.order_id}
                                        </div>
                                    )
                                })}


                            </Space>
                        </Col>
                        <Col span={24}>

                            <Space direction='horizontal'>
                                <Button type='link' onClick={e => { copy(record.code) }}>Copy mã</Button>
                                <Button onClick={e => openVoucher(record.id)} type='link'>Sửa </Button>
                                <Popconfirm
                                    title="Xoá"
                                    description="Bạn có chắc chăn muốn xoá?"
                                    onConfirm={e => deleteVoucher(record.id)}

                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button type='link' >Delete</Button>
                                </Popconfirm>


                            </Space>
                        </Col>
                    </Row >



                )



            }
        },









    ];

    return (
        <>

            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <Card style={{ width: "100%" }}>
                    <Space direction="vertical" size={8} style={{ width: "100%" }} >
                        <Search
                            placeholder="Voucher"
                            onSearch={onSearch}
                            style={{
                                width: "100%",
                            }}
                            onChange={onSearchChange}
                        />
                        <Flex justify='flex-end' style={{ width: "100%" }}>
                            <Button type='primary' onClick={e => openVoucher(null)}>Thêm mới</Button>
                        </Flex>
                    </Space>


                </Card>
                <Card style={{ width: "100%" }}>

                </Card>
                <Card style={{ width: "100%" }}>
                    <Table dataSource={data} columns={columns} showHeader={false}  />
                </Card>
            </Space>
            <VoucherModal open={isModalOpen} onClose={e => setIsModalOpen(false)} id={voucherID} onSaved={onVoucherSaved}></VoucherModal>
        </>
    )
}

export default OrderList;
